import type { CustomStepType } from '@/features/guidedTour/types';

const navSelectors = (isCardOrderHistoryEnabled: boolean): string[] => [
    'li[data-nav-item-key="overview"]',
    'li[data-nav-item-key="charging"]',
    ...(isCardOrderHistoryEnabled ? ['li[data-nav-item-key="chargingCards"]'] : []),
    'li[data-nav-item-key="invoices"]',
    'li[data-nav-item-key="administration"]',
];

/**
 * Builds the guided tour steps.
 *
 * When the Card Order History feature is enabled, card management lives under the
 * dedicated "Charging cards" tab (/charging-cards/management) instead of the
 * Administration tab, and Administration only holds the Charging contract page.
 */
export const getSteps = (isCardOrderHistoryEnabled = false): CustomStepType[] => {
    const highlightedSelectors = navSelectors(isCardOrderHistoryEnabled);

    return [
        {
            selector: 'body',
            highlightedSelectors,
            key: 'guidedTour.step.overview',
            route: '/dashboard',
        },
        {
            selector: 'div[data-testid="map-view-panel"]',
            key: 'guidedTour.step.overview.chargingStation',
            route: '/dashboard',
        },
        {
            selector: 'body',
            highlightedSelectors,
            key: 'guidedTour.step.charging',
            route: '/charging/activity',
        },
        {
            selector: 'body',
            highlightedSelectors,
            key: 'guidedTour.step.invoices',
            route: '/invoices',
        },
        isCardOrderHistoryEnabled
            ? {
                  selector: 'body',
                  highlightedSelectors: [...highlightedSelectors, 'li[data-nav-item-key="chargingCards"]'],
                  key: 'guidedTour.step.administration.cards',
                  route: '/charging-cards/management',
              }
            : {
                  selector: 'body',
                  highlightedSelectors: [...highlightedSelectors, 'li[data-nav-item-key="administration.cards"]'],
                  key: 'guidedTour.step.administration.cards',
                  route: '/administration/cards',
              },
        {
            selector: 'body',
            highlightedSelectors: [
                ...highlightedSelectors,
                ...(isCardOrderHistoryEnabled ? [] : ['li[data-nav-item-key="administration.contract"]']),
            ],
            key: 'guidedTour.step.administration.contract',
            route: '/administration/contract',
        },
    ];
};

// Default (feature toggle disabled) steps, kept for backwards compatibility.
export const steps: CustomStepType[] = getSteps(false);
